import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { WsCore } from './ws.core';
import { WsAuth } from './ws.auth';
import { WsInternalClient } from './ws.internal-client';
import { WsAccessControl } from './ws.access-control';
import { WsPlanning } from './ws.planning';
import { WsClubs } from './ws.clubs';

@Injectable()
export class WsService extends WsCore {
     planning: WsPlanning;
     auth: WsAuth;
     clubs: WsClubs;
     internalClient: WsInternalClient;
     accessControl: WsAccessControl;

     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
          this.planning = new WsPlanning(http, session);
          this.auth = new WsAuth(http, session);
          this.clubs = new WsClubs(http, session);
          this.internalClient = new WsInternalClient(http, session);
          this.accessControl = new WsAccessControl(http, session);
     }
}
